// "Sprzedaj wszystko" in the Warzywniak (owner 2026-10-03): sell every product you have, and say
// beforehand how much that earns. Pure, node --test.
export const MAX_PER_REQUEST = 99;   // backend SellProductRequest.quantity le=99

export function sellAllPlan(products, catalog, ids) {
  const requests = [];
  let total = 0;
  for (const item of ids) {
    let left = products?.[item] ?? 0;
    total += left * (catalog?.[item]?.price ?? 0);
    while (left > 0) { const qty = Math.min(left, MAX_PER_REQUEST); requests.push({ item, qty }); left -= qty; }
  }
  return { total, requests };
}
